// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".charging-map__panel__main__partners .logos{display:flex;flex-wrap:wrap;justify-content:space-evenly;align-items:center;gap:10px}.charging-map__panel__main__partners .logos a{margin-bottom:17px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
